import { StatusIndications } from '../common';

export interface RichTextToolbarPrivateUniDriver {
  clickLinkButton: () => void;
  insertUrl: (value: string) => void;
  // TODO: strongly type remaining methods
}
